<template>
    <div>
        <booking-header v-if="step && step != 'confirmation'"></booking-header>

        <booking-trip
            v-if="step == 'trip' && ticket != 'daytrip'"
            @showInfo="showInfo"
        ></booking-trip>

        <booking-daytrip
            v-if="step == 'trip' && ticket == 'daytrip'"
            @showInfo="showInfo"
        ></booking-daytrip>

        <booking-transfers
            v-if="step == 'transfers'"
        ></booking-transfers>

        <booking-passengers
            v-if="step == 'passengers'"
        ></booking-passengers>

        <booking-luggage-and-supplements
            v-if="step == 'supplements'"
        ></booking-luggage-and-supplements>

        <booking-payment
            v-if="step == 'payment'"
        ></booking-payment>

        <booking-confirmation
            v-if="step == 'confirmation'"
        ></booking-confirmation>

        <booking-page-footer ref="footer"></booking-page-footer>

        <loader :full-screen="true" v-if="processing"></loader>

    </div>
</template>

<script>
import BookingConfirmation from './BookingConfirmation.vue'
import BookingHeader from './BookingHeader.vue'
import BookingPassengers from './BookingPassengers.vue'
import BookingPayment from './BookingPayment.vue'
import BookingLuggageAndSupplements from './BookingLuggageAndSupplements.vue'
import BookingTransfers from './BookingTransfers.vue'
import BookingTrip from './BookingTrip.vue'
import BookingDaytrip from './BookingDaytrip.vue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import BookingSearch from './BookingSearch.vue'
import Loader from '../components/Loader.vue'
import BookingPageFooter from './BookingPageFooter.vue'
export default {
    components: {
        BookingPassengers,
        BookingTrip,
        BookingDaytrip,
        BookingPayment,
        BookingConfirmation,
        BookingLuggageAndSupplements,
        BookingTransfers,
        BookingHeader,
        BookingSearch,
        Loader,
        BookingPageFooter,
    },
    data() {
        return {
            loading: false,
            searchBackgroundImage: window.venezialines.theme_root+'/assets/media/app/search-banner.jpg',
        }
    },
    created() {
        let search = new URLSearchParams(window.location.search)
        if (search.get('action') == 'start') {
            this.resetState()
            let ticket = search.get('ticket')
            if (ticket.includes('daytrip')) {
                this.setTicket({ ticket: 'daytrip', multicity: ticket.includes('multicity')})
            }
            else if (ticket.includes('return')) {
                this.setTicket({ ticket: 'return', multicity: ticket.includes('multicity') })
            }
            else {
                this.setTicket({ ticket: 'oneway', multicity: false })
            }

            let outOrigin = this.getPortById(parseInt(search.get('out_origin')))
            let outDestination = this.getPortById(parseInt(search.get('out_destination')))
            let outDate = moment(search.get('out_date'), 'DD/MM/YYYY')

            if (outOrigin && outDestination) {
                this.setRoute({
                    origin: outOrigin.id,
                    destination: outDestination.id,
                    leg: 'out'
                })
            } else {
                this.$swal('Error', 'Invalid outward leg', 'error')
            }

            if (outDate.isValid()) {
                this.setDate({
                    date: outDate.format('YYYY-MM-DD'),
                    leg: 'out',
                })
            } else {
                this.$swal('Error', 'Invalid outward date', 'error')
            }

            if (this.ticket == 'return') {
                let retDate = moment(search.get('ret_date'), 'DD/MM/YYYY')

                if (retDate.isValid()) {
                    this.setDate({
                        date: retDate.format('YYYY-MM-DD'),
                        leg: 'ret',
                    })
                } else {
                    this.$swal('Error', 'Invalid return date', 'error')
                }
            }

            if (this.ticket != 'oneway') {
                if (this.multicity) {
                    let retOrigin = this.getPortById(parseInt(search.get('ret_origin')))
                    let retDestination = this.getPortById(parseInt(search.get('ret_destination')))
                    if (retOrigin && retDestination) {
                        this.setRoute({
                            origin: retOrigin.id,
                            destination: retDestination.id,
                            leg: 'ret'
                        })
                    } else {
                        this.$swal('Error', 'Invalid return leg', 'error')
                    }
                } else {
                    this.setRoute({
                        origin: outDestination.id,
                        destination: outOrigin.id,
                        leg: 'ret'
                    })
                }
            }

            this.setPassengersCount({
                adl: parseInt(search.get('pax_adl')),
                chd: parseInt(search.get('pax_chd')),
                inf: parseInt(search.get('pax_inf')),
            })

            this.setSteps()

            if (this.legs.out.origin && this.legs.out.destination && this.legs.out.date && this.passengersCount.adl) {
                this.setStep('trip')
            }
            
            history.replaceState(null, document.title, window.location.href.split('?')[0])
        }
        else if (search.get('number') && search.get('signature')) {
            this.resetState()
            this.setSteps()
            this.setStep('confirmation')
        }
    },
    mounted() {
        this.$store.commit('booking/stopProcessing')

        if (!this.step) {
            this.$swal('Error', 'Invalid or expired booking request, please return to the homepage', 'error')
        }
    },
    computed: {
        ...mapState('booking', [
            'ticket',
            'step',
            'legs',
            'passengersCount',
            'multicity',
            'processing',
            'validationErrors',
            'apiError',
        ]),
        ...mapGetters([
            'getPortById'
        ]),
    },
    watch: {
        validationErrors(value) {
            if (value.length) {
                this.$swal('Error', value.join("\n"), 'error')
            }
        },
        apiError(value) {
            if (value.length) {
                this.$swal('Error', value, 'error').then(() => this.setApiError(''))
            }
        }
    },
    methods: {
        showInfo(section) {
            this.$refs.footer.showInfo(section)
        },
        ...mapMutations('booking', [
            'setTicket',
            'setStep',
            'setRoute',
            'setTrip',
            'setPassengersCount',
            'setDate',
            'resetState',
            'setApiError',
        ]),
        ...mapActions('booking', [
            'setSteps',
            'reset'
        ]),
    }
}
</script>